var _regeneratorRuntime = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/regenerator");

var _slicedToArray = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/helpers/slicedToArray");

var _asyncToGenerator = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _defineProperty = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/helpers/defineProperty");

var _objectWithoutProperties = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _classCallCheck = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/helpers/inherits");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Asset = require('./Asset');

var POLL_INTERVAL = 2500;

var NativeAsset =
/*#__PURE__*/
function (_Asset) {
  "use strict";

  _inherits(NativeAsset, _Asset);

  function NativeAsset(_ref) {
    var _this;

    var _ref$pollInterval = _ref.pollInterval,
        pollInterval = _ref$pollInterval === void 0 ? POLL_INTERVAL : _ref$pollInterval,
        props = _objectWithoutProperties(_ref, ["pollInterval"]);

    _classCallCheck(this, NativeAsset);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NativeAsset).call(this, _objectSpread({}, props, {
      type: 'native'
    })));
    _this._pollInterval = pollInterval;
    return _this;
  }

  _createClass(NativeAsset, [{
    key: "getBalance",
    value: function getBalance(account) {
      return this.getWeb3().eth.getBalance(account);
    }
  }, {
    key: "supportsMessages",
    value: function supportsMessages() {
      return true;
    }
  }, {
    key: "startWatchingAddress",
    value: function startWatchingAddress(address) {
      var _this2 = this;

      var running = true;
      var block = 0;
      var balance = 0;

      var poll =
      /*#__PURE__*/
      function () {
        var _ref2 = _asyncToGenerator(
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee() {
          var web3, _ref3, _ref4, currentBlock, currentBalance, offsetBalance;

          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (running) {
                    _context.next = 2;
                    break;
                  }

                  return _context.abrupt("return");

                case 2:
                  _context.prev = 2;
                  web3 = _this2.getWeb3();
                  _context.next = 6;
                  return Promise.all([web3.eth.getBlockNumber(), web3.eth.getBalance(address)]);

                case 6:
                  _ref3 = _context.sent;
                  _ref4 = _slicedToArray(_ref3, 2);
                  currentBlock = _ref4[0];
                  currentBalance = _ref4[1];

                  if (!(block !== 0 && balance !== currentBalance)) {
                    _context.next = 15;
                    break;
                  }

                  offsetBalance = web3.utils.toBN(balance).add(web3.utils.toBN(_this2.getBalanceDelta(address, block + 1, currentBlock)));

                  if (!(offsetBalance !== currentBalance)) {
                    _context.next = 15;
                    break;
                  }

                  _context.next = 15;
                  return _this2.scanBlocks(address, block + 1, currentBlock);

                case 15:
                  block = currentBlock;
                  balance = currentBalance;
                  _context.next = 22;
                  break;

                case 19:
                  _context.prev = 19;
                  _context.t0 = _context["catch"](2);
                  console.warn('Polling Address failed', _context.t0);

                case 22:
                  setTimeout(poll, _this2._pollInterval);

                case 23:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[2, 19]]);
        }));

        return function poll() {
          return _ref2.apply(this, arguments);
        };
      }();

      poll();

      var unsubscribe = function unsubscribe() {
        running = false;
      };

      this.cleanupFunctions.push(unsubscribe);
      return unsubscribe;
    }
  }, {
    key: "scanBlocks",
    value: function () {
      var _scanBlocks = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(address, startBlock, toBlock) {
        var _this3 = this;

        var _address, web3, blockNums, blockNum;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _address = address.toLowerCase();
                web3 = this.getWeb3();
                blockNums = [];

                for (blockNum = startBlock; blockNum <= toBlock; blockNum += 1) {
                  blockNums.push(blockNum);
                }

                _context4.next = 6;
                return Promise.all(blockNums.map(
                /*#__PURE__*/
                function () {
                  var _ref5 = _asyncToGenerator(
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee3(blockNum) {
                    var block;
                    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            _context3.next = 2;
                            return web3.eth.getBlock(blockNum);

                          case 2:
                            block = _context3.sent;
                            _context3.next = 5;
                            return Promise.all(block.transactions.map(
                            /*#__PURE__*/
                            function () {
                              var _ref6 = _asyncToGenerator(
                              /*#__PURE__*/
                              _regeneratorRuntime.mark(function _callee2(txHash) {
                                var tx;
                                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                                  while (1) {
                                    switch (_context2.prev = _context2.next) {
                                      case 0:
                                        _context2.next = 2;
                                        return web3.eth.getTransaction(txHash);

                                      case 2:
                                        tx = _context2.sent;

                                        if (tx.value !== '0' && tx.to.toLowerCase() === _address) {
                                          _this3.core.addHistoryEvent({
                                            asset: _this3.id,
                                            type: 'send',
                                            value: tx.value,
                                            from: tx.from,
                                            to: tx.to,
                                            message: tx.input.length > 2 ? web3.utils.toUtf8(tx.input) : null,
                                            tx: tx.hash,
                                            timestamp: block.timestamp
                                          });
                                        }

                                      case 4:
                                      case "end":
                                        return _context2.stop();
                                    }
                                  }
                                }, _callee2);
                              }));

                              return function (_x5) {
                                return _ref6.apply(this, arguments);
                              };
                            }()));

                          case 5:
                          case "end":
                            return _context3.stop();
                        }
                      }
                    }, _callee3);
                  }));

                  return function (_x4) {
                    return _ref5.apply(this, arguments);
                  };
                }()));

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function scanBlocks(_x, _x2, _x3) {
        return _scanBlocks.apply(this, arguments);
      }

      return scanBlocks;
    }()
  }, {
    key: "getBalanceDelta",
    value: function getBalanceDelta(address, startBlock, endBlock) {
      var web3 = this.getWeb3();
      return this.core.getHistoryEvents({
        asset: this.id,
        fromBlock: startBlock,
        toBlock: endBlock
      }).filter(function (event) {
        return event.to === address || event.from === address;
      }).reduce(function (reducer, event) {
        return event.to === address ? web3.utils.toBN(reducer).add(web3.utils.toBN(event.value)) : web3.utils.toBN(reducer).sub(web3.utils.toBN(event.value));
      }, '0');
    }
  }, {
    key: "_send",
    value: function () {
      var _send2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(_ref7) {
        var message, params, web3, data, receipt;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                message = _ref7.message, params = _objectWithoutProperties(_ref7, ["message"]);
                web3 = this.getWeb3();
                data = message ? web3.utils.fromUtf8(message) : undefined;
                _context5.next = 5;
                return web3.eth.sendTransaction(_objectSpread({
                  data: data
                }, params));

              case 5:
                receipt = _context5.sent;
                return _context5.abrupt("return", _objectSpread({}, receipt, {
                  txHash: receipt.transactionHash
                }));

              case 7:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function _send(_x6) {
        return _send2.apply(this, arguments);
      }

      return _send;
    }()
  }, {
    key: "getTx",
    value: function () {
      var _getTx = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6(txHash) {
        var web3, tx;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                web3 = this.getWeb3();
                _context6.next = 3;
                return web3.eth.getTransaction(txHash);

              case 3:
                tx = _context6.sent;

                if (tx) {
                  _context6.next = 6;
                  break;
                }

                return _context6.abrupt("return", null);

              case 6:
                return _context6.abrupt("return", {
                  assetName: this.name,
                  from: tx.from,
                  to: tx.to,
                  value: tx.value,
                  displayValue: this.getDisplayValue(tx.value),
                  message: tx.input.length > 2 ? web3.utils.toUtf8(tx.input) : null
                });

              case 7:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getTx(_x7) {
        return _getTx.apply(this, arguments);
      }

      return getTx;
    }()
  }]);

  return NativeAsset;
}(Asset);

module.exports = NativeAsset;